import React from "react";
import { ArrowRight, Shield, Cross } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GarderenBagTroen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="garderen-bag-troen" className="dark bg-background text-foreground relative min-h-[90vh] flex flex-col justify-center overflow-hidden border-b-4 border-border" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none z-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] mix-blend-overlay"></div>

      {}
      <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-2 h-full w-full z-0">
        {}
        <div className="relative h-full w-full overflow-hidden border-r-0 md:border-r-2 border-border/50 group">
          <div className="absolute inset-0 bg-secondary/40 mix-blend-multiply z-10 transition-opacity duration-700 group-hover:opacity-20"></div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/christian_guard_uniform_archival.png" alt="Christian Bak i Den Kongelige Livgarde uniform" className="h-full w-full object-cover object-center grayscale contrast-125 transition-transform duration-1000 ease-out scale-105 group-hover:scale-100" />
          <div className="absolute bottom-0 left-0 p-6 z-20 md:hidden">
            <span className="bg-background/90 text-foreground px-3 py-1 text-xs font-mono uppercase tracking-widest border border-border">
              Fortiden: Disciplin & Karakterstyrke
            </span>
          </div>
        </div>

        {}
        <div className="relative h-full w-full overflow-hidden group">
          <div className="absolute inset-0 bg-background/20 mix-blend-overlay z-10"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent md:bg-gradient-to-l md:from-transparent md:via-transparent md:to-background/80 z-10"></div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/christian_modern_portrait.png" alt="Christian Bak nutidigt portræt" className="h-full w-full object-cover object-center transition-transform duration-1000 ease-out scale-105 group-hover:scale-100" />
          <div className="absolute bottom-0 right-0 p-6 z-20 md:hidden text-right">
            <span className="bg-background/90 text-foreground px-3 py-1 text-xs font-mono uppercase tracking-widest border border-border">
              Nutiden: Tro & Eksistens
            </span>
          </div>
        </div>
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 md:px-8 flex flex-col items-center justify-center text-center h-full py-20">
        <div className={`transition-all duration-1000 delay-300 transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className="mb-6 flex justify-center items-center gap-4 opacity-80">
            <Shield className="w-8 h-8 text-primary stroke-[1.5]" />
            <div className="h-px w-16 bg-primary/50"></div>
            <Cross className="w-8 h-8 text-primary stroke-[1.5]" />
          </div>

          {}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-9xl font-bold tracking-tighter text-white relative inline-block">
            <span className="absolute inset-0 text-transparent [-webkit-text-stroke:2px_var(--color-border)] md:[-webkit-text-stroke:3px_var(--color-border)] select-none z-[-1] blur-sm opacity-50">
              CHRISTIAN BAK –
              <br />
              GARDEREN BAG TROEN
            </span>
            <span className="relative z-10 drop-shadow-2xl [-webkit-text-stroke:1px_black] md:[-webkit-text-stroke:2px_black]">
              CHRISTIAN BAK –
              <br />
              GARDEREN BAG TROEN
            </span>
          </h1>

          {}
          <div className="mt-8 max-w-2xl mx-auto bg-background/95 border-2 border-border p-6 md:p-8 shadow-xl backdrop-blur-sm">
            <p className="text-lg md:text-xl font-serif leading-relaxed text-muted-foreground">
              Christian Bak forener samfundsdebat og militær disciplin i en kompromisløs kamp for karakterdannelse og kristen etik. Et opgør med hykleri gennem personligt ansvar, hvor samfund & moral, disciplin & karakterstyrke samt tro & eksistens danner fundamentet.
            </p>
            
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto rounded-none border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 font-mono uppercase tracking-wider text-sm">
                <Link to="/JourneyPage">
                  LÆS HISTORIEN OM CHRISTIAN BAK – MILITÆR DISCIPLIN & KARAKTERDANNELSE <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-none border-2 border-border bg-transparent hover:bg-accent hover:text-accent-foreground font-mono uppercase tracking-wider text-sm">
                <Link to="/FrontlinePage">
                  MARSER TIL FRONTLINJEN – PERSONLIGT ANSVAR
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-0 right-0 z-20 hidden md:flex justify-between px-12 pointer-events-none">
        <div className="flex items-center gap-3">
          <span className="text-4xl font-serif font-bold text-white/20">I.</span>
          <div className="text-xs font-mono uppercase tracking-widest text-white/60 bg-black/50 px-2 py-1 backdrop-blur-md">
            Den Kongelige Livgarde – Samfund & Moral
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-xs font-mono uppercase tracking-widest text-white/60 bg-black/50 px-2 py-1 backdrop-blur-md">
            Kristen Aktivisme – Kristen Etik
          </div>
          <span className="text-4xl font-serif font-bold text-white/20">II.</span>
        </div>
      </div>
    </section>;
}